<!--  -->
<template>
  <el-dialog
    :title = "$t('device.查看设备')"
    v-bind="$attrs"
    class="dialog-dark setting-dialog"
    v-on="$listeners"
  >
    <div v-if="deviceInfo" class="lookdevice-container">
      <p class="lookdevice-avatar">
        <img class="lookdevice-avatar__img" :src="require('@/svg/chatavatar_7.svg')">
      </p>
      <p class="lookdevice-name">{{ deviceInfo.name }}</p>
      <ul class="lookdevice-list">
        <li>
          <h4>{{$t('device.设备类型')}}</h4>
          <p v-if="deviceDetailInfo">{{ platform(deviceDetailInfo)}}</p>
        </li>
        <li>
          <h4>{{$t('device.浏览器')}}</h4>
          <p v-if="deviceDetailInfo">{{ deviceDetailInfo.browserName }}</p>
        </li>
        <li>
          <h4>{{$t('device.网络运营商')}}</h4>
          <p  v-if="deviceDetailInfo">{{deviceDetailInfo.isp}}</p>
        </li>
        <li>
          <h4>{{$t('device.ip地址')}}</h4>
          <p v-if="deviceDetailInfo">{{ deviceDetailInfo.ipAddr }}</p>
        </li>
      </ul>
      <el-button
        class="lookdevice-btn"
        size="small"
        type="primary"
        @click="closeDevice"
        >{{$t('device.我知道了')}}</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { getUidUserInfo } from "@/api/liveRequest/userApi";
export default {
  name: "device",
  data() {
    return {
      deviceDetailInfo: null,
      isLook:true
    };
  },
  props: ["deviceInfo"],
  watch: {
    $attrs: {
      handler(value) {
        if (!value.visible) {
          this.closeDevice();
            this.isLook = false
        } else {
        
          if(this.isLook)return;
            this.isLook = true
          this.init();
        }
      },
    },
  },
  computed: {
    liveToken() {
      return this.$store.getters.liveToken;
    },
    platform() {
      return (info) => {
        let platform = "windows";
        if (info.deviceType == 0) {
          platform = "windows";
        } else if (info.deviceType == 1) {
          platform = "mac";
        }
        return platform;
      };
    },
  },
  methods: {
    init() {
      getUidUserInfo(this.deviceInfo.uid, this.liveToken).then((res) => {
        console.log(res, "deviceDetailInfo");
        if (res && res.code == 200) {
          this.deviceDetailInfo = res.data;
        }
      });
    },
    closeDevice() {
      this.$parent.openDevice = false;
    },
  },
};
</script>
<style lang='scss' scoped>
.lookdevice-container {
  width: 500px;
  height: 220px;
  .lookdevice-name {
    margin-top: 5px;
  }
  .lookdevice-list {
    margin: 30px 0px;
    font-size: 12px;
    line-height: 1;
    h4 {
      margin-bottom: 24px;
      color: #ACB2BF;
    }
    > li {
      display: inline-block;
      padding: 0 20px;
      &:not(:last-child) {
        border-right: 1px solid #262945;
      }
    }
  }
  .lookdevice-btn {
    margin: 20px;
    padding-top: 7px;
    padding-bottom: 7px;
    float: right;
    border-radius: 6px;
    &:not(:hover) {
      background-color: #3986EE;
    }
  }
}
.lookdevice-avatar {
  margin-top: 15px;
  &__img {
    width: 50px;
    vertical-align: middle;
  }
}

.dialog-dark ::v-deep {
  .el-dialog,
  .el-dialog__header,
  .el-dialog__body {
    background: #2D3052;
  }
}
</style>
